<template>
  <div :class="computedClass">
    {{ formatDateValue(value) || ' - ' }}
  </div>
</template>

<script>
export default {
  name: 'DataTableTextColumn',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Object,
      default() {
        return {
          shouldWrap: false,
        }
      },
    },
  },
  computed: {
    computedClass() {
      return {
        noWrap: !this.options.shouldWrap,
      }
    },
  },
  methods: {
    formatDateValue(value) {
      if(value.indexOf("-")){
        let valueInput = value.split('-');
        if (valueInput.length >= 3 && !isNaN(valueInput[0]) && !isNaN(valueInput[1])) {
          let data = new Date(value);
          let dataFormatada = `${this.addZero(data.getDate())}/${this.addZero(data.getMonth() + 1)}/${data.getFullYear()}`;
          return dataFormatada;
        } else {        
          return value;
        }
      }
    },
    addZero(numero) {
      if (numero <= 9)
        return "0" + numero;
      else
        return numero;
    }
  }
}
</script>
